export default {
  components: {
    TheHeader: () => import("@layout/TheHeader.Jtails"),
    TheFooterJtails: () => import("@layout/TheFooter.Jtails"),
    TheFooterDingBeauty: () => import("@layout/TheFooter.DingBeauty"),
  },
  computed: {
    isShowHeader() {
      return !this.$globalIsLiffClient || this.$route.meta.liffShowMenu !== false
    },
    isShowFooter() {
      return !this.$globalIsLiffClient || this.$route.meta.liffShowMenu !== false
    }
  },
}
